module.exports = __webpack_public_path__ + "static/img/default-header.68e72471.png";